import { logger as garnishLogger } from '@garnish/logger';

export const customizationLogger = garnishLogger.extend('CUSTOMIZATION');
garnishLogger.enable('CUSTOMIZATION');
